export { TitleAtom, type TitleAtomProps } from "./TitleAtom";
